export default "__VITE_ASSET__DshQVJuH__"